"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectableOptionMenuItemType = void 0;
var SelectableOptionMenuItemType;
(function (SelectableOptionMenuItemType) {
    SelectableOptionMenuItemType[SelectableOptionMenuItemType["Normal"] = 0] = "Normal";
    SelectableOptionMenuItemType[SelectableOptionMenuItemType["Divider"] = 1] = "Divider";
    SelectableOptionMenuItemType[SelectableOptionMenuItemType["Header"] = 2] = "Header";
    SelectableOptionMenuItemType[SelectableOptionMenuItemType["SelectAll"] = 3] = "SelectAll";
})(SelectableOptionMenuItemType || (exports.SelectableOptionMenuItemType = SelectableOptionMenuItemType = {}));
//# sourceMappingURL=SelectableOption.types.js.map